import Vue from 'vue';
import { getAIAgentSettings } from 'widget/api/aiAgent';

const state = {
  data: {
    enabled: false,
    name: '',
    avatarUrl: '',
  },
  uiFlags: {
    isError: false,
    hasFetched: false,
  },
};

export const getters = {
  getHasFetched: $state => $state.uiFlags.hasFetched,
  aiAgent: $state => $state.data,
  isEnabled: $state => $state.data.enabled,
};

export const actions = {
  fetch: async ({ commit }, websiteToken) => {
    try {
      const { data } = await getAIAgentSettings(websiteToken);
      commit('set', data);
      commit('setError', false);
      commit('setHasFetched', true);
    } catch (error) {
      commit('setError', true);
      commit('setHasFetched', true);
    }
  },
};

export const mutations = {
  set($state, data) {
    Vue.set($state, 'data', {
      enabled: data.enabled || false,
      name: data.name || '',
      avatarUrl: data.avatar_url || '',
    });
  },
  setError($state, value) {
    Vue.set($state.uiFlags, 'isError', value);
  },
  setHasFetched($state, value) {
    Vue.set($state.uiFlags, 'hasFetched', value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
